import { AuthLoginByOtacHelper } from '@sravni/utils/lib/auth';

import { IAuthSMSRequest, IAuthSMSVerifyRequest } from '../interfaces/auth';
import { IAuthSMSVerifyResponse } from '../interfaces/phoneVerifier';

import ProxyClient from './clients/ProxyClient';

export const signinUser = async (requestData: IAuthSMSRequest) => {
  const { data } = await ProxyClient.post('/user/signin', requestData);
  return data;
};

export const verifyUser = async (requestData: IAuthSMSVerifyRequest) => {
  const { data } = await ProxyClient.post('/user/verify', requestData);
  return data;
};

export const tryAuth = async (
  authHelper: AuthLoginByOtacHelper,
  { otac, username }: Pick<IAuthSMSVerifyResponse, 'otac' | 'username'>,
  onSuccessAuth?: () => void,
) => {
  try {
    await authHelper.login({ otac, hint: username });
    onSuccessAuth?.();
  } catch (e) {
    authHelper.destroy();
    console.error(e);
  }
};
